import React, { useState, useEffect } from "react";
import { FaFileInvoice, FaUsers, FaSlideshare } from "react-icons/fa";
import { MdSpaceDashboard, MdPeople } from "react-icons/md";
import { GiExpense } from "react-icons/gi";
import { AiOutlineTransaction } from "react-icons/ai";
import { TbMessages } from "react-icons/tb";
import "../Assets/Css/Sidebar.scss";
import { Link } from "react-router-dom";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../Lib/Init-firebase";


const Sidebar = ({ menuCollapse, menuIconClick }) => {
  const [message, setMessage] = useState([]);

  let path = window.location.pathname;
  const myArray = path.split('/');
  let result = myArray[1];

  console.log(message,"main")
  useEffect(() => {
    const messageCollectionRef = collection(db, "users");
    const unViewMessage = onSnapshot(messageCollectionRef, (snapshot) => {
      setMessage(
        snapshot.docs.map((doc) => ({
          id: doc.id,
        }))
      );
    });
    return () => {
      unViewMessage();
    };
  }, []);

  return (
    <>
      <div className={`side ${menuCollapse ? "side-closed side-bar" : "show-sidebar"}`}>
        <div className="items">
          <div className="ed">
            <div className="part-1">
              {menuCollapse ? (
                <img
                  src={require("../Assets/Images/Sidebar/companylogo.png")}
                  width="40"
                  alt="closedigit"
                />
              ) : (
                <img
                  src={require("../Assets/Images/Sidebar/Group.png")}
                  width="230"
                  alt="closedigit"
                />
              )}
            </div>
          </div>
          <div className={`${menuCollapse ? "part-2-closed" : "part-2"}`}>
            <ul className={`${menuCollapse ? "ul-closed" : ""}`}>
              <Link
                to="/dashboard"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"
                    } ${result === 'dashboard' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <MdSpaceDashboard className="icon-size" />
                      <span className="tooltip">Dashboard</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Dashboard</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link>
              <Link
                to="/invoice"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'invoice' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      {" "}
                      <FaFileInvoice className="icon-size" />
                      <span className="tooltip">Invoices</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Invoices</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link>
              <Link
                to="/transaction"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} 
                  ${result === 'transaction' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <AiOutlineTransaction className="icon-size" />
                      <span className="tooltip">Transaction</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Transaction</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link>
              <Link
                to="/shareholder"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'shareholder' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <FaSlideshare className="icon-size" />
                      <span className="tooltip">Share Holders</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Share Holders</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link>
              <Link
                to="/spends"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'spends' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <GiExpense className="icon-size" />
                      <span className="tooltip">Spends</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Spends</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link>
              <Link
                to="/clients"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'clients' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <FaUsers className="icon-size" />
                      <span className="tooltip">Clients</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Clients</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link>
              {/* <Link
                to="/employees"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'employees' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <MdPeople className="icon-size" />
                      <span className="tooltip">Employees</span>
                    </div>
                    {menuCollapse ? (
                      ""
                    ) : (
                      <div className="family">
                        <span className="spa">Employees</span>
                      </div>
                    )}
                  </div>
                </li>
              </Link> */}
              <Link
                to="/messages"
                style={{ textDecoration: "inherit", color: "inherit" }}
              >
                <li
                  className={`${menuCollapse ? "ind-item-closed" : "ind-item"} ${result === 'messages' ? 'active-block' : ''}`}
                >
                  <div className={`${menuCollapse ? "i-closed" : "i"}`}>
                    <div className="padder">
                      <TbMessages className="icon-size" />
                      <span className='tooltip'>Messages</span>
                    </div>
                    {menuCollapse ? (
                      <div className="count-up">
                        <span className="message">{message.length}</span>
                      </div>
                    ) : (
                      <>
                        <div className="family">
                          <span className="spa">Messages</span>
                        </div>
                        <div className="count">
                          <span className="message">{message.length}</span>
                        </div>
                      </>
                    )}
                  </div>
                </li>
              </Link>
            </ul>
          </div>
        </div>

      </div>
      <div className="body-overlay"></div>
    </>
  );
};

export default Sidebar;
